import { render, staticRenderFns } from "./OnSell.vue?vue&type=template&id=5e8a1263&scoped=true&"
import script from "./OnSell.vue?vue&type=script&lang=js&"
export * from "./OnSell.vue?vue&type=script&lang=js&"
import style0 from "./OnSell.vue?vue&type=style&index=0&id=5e8a1263&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8a1263",
  null
  
)

export default component.exports